<div class="page-list ">
    <div *ngIf="pageType!='BLOG'  && pageType!='NEWS' " class="header">
        <!--        <div class="background">-->
        <!--            <img src="assets/images/stories.png">-->
        <!--        </div>-->
        <div class="desc centerWidth">
            <h2>{{listTitle}}</h2>
            <p>
                {{listSummery}}
            </p>
            <!--            <button class="button darkblue" (click)="clickMoreList()">-->
            <!--                <span i18n="@@See more">See more</span>-->
            <!--                <i class="pi pi-angle-left"></i>-->
            <!--            </button>-->

        </div>

    </div>
    <div *ngIf="pageType=='BLOG' || pageType=='NEWS'" class="header">
        <div class="background centerWidth">
            <img *ngIf="topPage.style.bgImage !=null &&  topPage.style.bgImage.length>1" [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +topPage.style.bgImage ">
        </div>
        <div class="desc centerWidth">
            <h2>{{topPage.title}}</h2>
            <p>
                {{topPage.summary}}
            </p>
            <button class="button darkblue" (click)="goToPage(topPage.uid)">
                <span i18n="@@See more">See more</span>
                <i class="pi pi-angle-left"></i>
            </button>

        </div>

    </div>


    <!--    <div style="height:105px;">-->
    <!--        <div i18n="@@Brands who trust in Searchia:" style="text-align: center;font-weight: bold;">Brands who trust in-->
    <!--            Searchia:-->
    <!--        </div>-->
    <!--        <app-bottom-slider [logoType]="1" [opacity]="false"></app-bottom-slider>-->
    <!--    </div>-->

    <div id="page-list" class="col-12 block lg:flex centerWidth  ">
        <div class="col-12 lg:col-9 flex flex-wrap">
            <p-dataView #dv [value]="pages" [rows]="defListCount" [paginator]="true"
                        [totalRecords]="totalPages"
                        [lazy]="true" (onLazyLoad)="loadPageData(dv)"
            >
                <ng-template let-pagess pTemplate="list">
                    <div *ngFor="let page of pagess" class="col-12 lg:col-6 xl:col-6">
                        <app-page-list-item bgColor="{{page.style != null ? page.style.bgColor: ''}}"
                                            text="{{page.summary}}"
                                            title="{{page.title}}"
                                            logoSrc="{{page.style != null ? page.style.logoImage: ''}}"
                                            imgSrc="{{page.style != null ?  page.style.bgImage :''}}"
                                            [uid]="page.uid"
                                            [pageType]="pageType"
                        ></app-page-list-item>
                    </div>
                    <!--                    &lt;!&ndash;            ............................................&ndash;&gt;-->
                    <!--                    <button class=" button col-12 ">-->
                    <!--                        <span i18n="@@See more">See more</span>-->
                    <!--                    </button>-->
                </ng-template>
            </p-dataView>

        </div>
        <div [hidden]=" (attributFilterList | keyvalue).length<1" class="col-12  lg:col-3 ">
            <div i18n="@@Filter by" style="font-weight: bold;">Filter by</div>
            <p-accordion [multiple]="true">
                <p-accordionTab *ngFor="let attr of attributFilterList | keyvalue;let i = index"
                                [selected]="i==0? true : false"
                                [header]="attr.key">
                    <div *ngFor="let attrVal of attr.value">
                        <p-checkbox [binary]="true"
                                    (onChange)="filterByAttribute($event,attr.key.trim()+':'+attrVal.trim())"></p-checkbox>
                        <label>{{attrVal}}</label>
                    </div>
                </p-accordionTab>
            </p-accordion>

        </div>
    </div>
    <!--    <div class="col-12">-->
    <!--        <app-performance-section></app-performance-section>-->
    <!--    </div>-->


</div>